import React from 'react';
import { NavLink } from 'react-router-dom';
const Us1_mid_sub = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_art" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Fine Arts</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_ela" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >ELA</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_for" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Foreign Languages</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_hea" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Health Education</NavLink>    

      <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_mat" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Math</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_voc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Vocational/Life Skills</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_phy" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Physical Education</NavLink>
        
      <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_sci" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Science</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_soc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Social Studies</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_mid/us1_mid_ste" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >STEM/Technology</NavLink>
        
    </div>
  );
}

export default Us1_mid_sub;
